import { render, staticRenderFns } from "./PageEntities.vue?vue&type=template&id=2910adca&scoped=true"
import script from "./PageEntities.vue?vue&type=script&lang=js"
export * from "./PageEntities.vue?vue&type=script&lang=js"
import style0 from "./PageEntities.vue?vue&type=style&index=0&id=2910adca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2910adca",
  null
  
)

export default component.exports